var map = {
	"./ceo-introduction@2x.png": 65,
	"./financial-performance@2x.png": 66,
	"./focus-areas@2x.png": 67,
	"./future-energy@2x.png": 68,
	"./governance@2x.png": 69,
	"./operations@2x.png": 70,
	"./people@2x.png": 71,
	"./uk-power-network-services@2x.png": 72,
	"./ukpn-annual-review-2017@2x.png": 73,
	"./vision-values@2x.png": 74
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 863;


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/covers ^\.\/.*@2x\.png$
// module id = 863
// module chunks = 0